// extracted by mini-css-extract-plugin
export default {"enabledConfigurationButton":"ApprovalConfigurationButtonSwitch_enabledConfigurationButton__UGhyA"};